import { CircularProgress, Modal } from '@mui/material';

import styles from './ModalSuspenseFallback.module.css';

/**
 * Shown while a lazy modal's chunk downloads (first open after a load/deploy) so the click is acknowledged.
 * Modal sizes differ, so this shows only a spinner, not a paper shell. The backdrop is invisible because the
 * real Dialog fades its own backdrop in from zero, and swapping from a dimmed one would flash.
 * The Modal root still covers the page, which blocks repeat clicks while loading.
 */
export default function ModalSuspenseFallback() {
	return (
		<Modal
			open
			disableAutoFocus
			slotProps={{ backdrop: { invisible: true } }}
		>
			<div className={styles.container}>
				<CircularProgress />
			</div>
		</Modal>
	);
}
